import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsOutline, ND} from '@pt/pt-models';
import {DashboardItem} from "it/primatoo/openapi/api/org/schemas/DashboardItem";

@Component({
  selector: 'pt-dashboard-card',
  template: `
    <div class='card dashboard-card'
         [ngClass]='{"clickCable": isClickCable}'
         (click)='clickAction.emit(true)'>
      <div class='card-body'>
        <div class='card-title' [ngStyle]='{"font-size": titleFontSizePx}'>
          <span class="text-ellipsis" container='body' [ngbTooltip]='title'>{{ title }}</span>
          <pt-image-renderer [type]='dashboardItem' [width]="iconSize" [showIcon]="showIcon"></pt-image-renderer>
        </div>

        <div class='card-text'>
          <span [style.font-size]="contentFontSizePx">{{ content ? content : 0 }}</span>
          <pt-icon class="float-end" [key]='IconArrowRight' [size]="arrowSize"></pt-icon>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .dashboard-card {
      background-color: white;
      color: var(--ptAppColor);
      border-color: color-mix(in oklab, currentColor, transparent 92%);
    }

    .dashboard-card:hover {
      border-color: color-mix(in oklab, currentColor, transparent 95%);
      background-color: color-mix(in oklab, currentColor, transparent 85%);
    }

    .clickCable {
      cursor: pointer;
    }

    .clickCable:hover {
      opacity: 0.95;
    }

    .card-title {
      display: flex;
      align-items: center;
      margin-bottom: 1.2rem;
      justify-content: space-between;
    }

    .card-text {
      display: flex;
      line-height: 1;
      align-items: center;
      justify-content: space-between;
    }
    .card-body {
      height: 126px;
    }
  `]
})
export class DashboardCardComponent {

  @Input() title: string;
  @Input() showIcon = true;
  @Input() dashboardItem: DashboardItem;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: any;
  @Input() iconSize = 22;
  @Input() arrowSize = 22;
  @Input() isClickCable = false;
  @Input() titleFontSizePx = '18px';
  @Input() contentFontSizePx = '25px';

  @Output() clickAction: EventEmitter<boolean> = new EventEmitter<boolean>();

  ND = ND;
  public IconArrowRight = IoniconsOutline.arrowRight;
}
